export default __webpack_public_path__ + "static/media/light-folder.089da7ce.png";